export const services = [
  {
    _id: "5d4sf8d8",
    service: "trading",
  },
  {
    _id: "8d7dfdf5",
    service: "alpha",
  },
  {
    _id: "d78fdsr8e",
    service: "smart security",
  },
  {
    _id: "ier88ers",
    service: "advertising",
  },
  {
    _id: "sfd7e3rs9f",
    service: "daily income",
  },
];
